import PropTypes from 'prop-types';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
const SystemMessageTimeToolTip = ({
  timestamp
}) => {
  const momentTimestamp = I18n.moment(timestamp);
  return timestamp ? /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: momentTimestamp,
      format: "lll",
      type: "userTz"
    }),
    children: /*#__PURE__*/_jsx("span", {
      "data-test-id": "system-message-time-tooltip",
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: momentTimestamp,
        format: "LT",
        type: "userTz"
      })
    })
  }) : null;
};
SystemMessageTimeToolTip.displayName = 'SystemMessageTimeToolTip';
SystemMessageTimeToolTip.propTypes = {
  timestamp: PropTypes.number
};
export default SystemMessageTimeToolTip;